import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import MarketingHome from "@/pages/Marketing";
import AppShell from "@/pages/AppShell";
import { PricingPage, AuthPage, KycPage, KycComplete, ForgotPasswordPage, ResetPasswordPage, ContactPage, PaymentResult, ShareView } from "@/pages/Commerce";
import ResourcesPage from "@/pages/Resources";
import { VerifyPage } from "@/pages/Certificate";
import { TermsPage, PrivacyPage, KycPage2, CookiesPage } from "@/pages/Legal";
import { BackToTop, CookieBanner } from "@/components/SiteChrome";

function App() {
  useEffect(() => {
    document.title = "ValueStackHQ";
    const l1 = document.createElement("link");
    l1.rel = "stylesheet";
    l1.href = "https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@400;500;600;700&family=Inter:wght@400;500;600&family=IBM+Plex+Mono:wght@400;500;600&display=swap";
    document.head.appendChild(l1);
  }, []);
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<MarketingHome />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/login" element={<AuthPage mode="login" />} />
            <Route path="/signup" element={<AuthPage mode="signup" />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/resources" element={<ResourcesPage />} />
            <Route path="/resources/:section" element={<ResourcesPage />} />
            <Route path="/kyc" element={<KycPage />} />
            <Route path="/kyc/complete" element={<KycComplete />} />
            <Route path="/app" element={<AppShell />} />
            <Route path="/payment/success" element={<PaymentResult mode="success" />} />
            <Route path="/payment/cancel" element={<PaymentResult mode="cancel" />} />
            <Route path="/s/:token" element={<ShareView />} />
            <Route path="/verify" element={<VerifyPage />} />
            <Route path="/verify/:certId" element={<VerifyPage />} />
            <Route path="/legal/terms" element={<TermsPage />} />
            <Route path="/legal/privacy" element={<PrivacyPage />} />
            <Route path="/legal/kyc" element={<KycPage2 />} />
            <Route path="/legal/cookies" element={<CookiesPage />} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
          <BackToTop />
          <CookieBanner key="global-cookie" />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
export default App;
